import { FormattedMessage, IntlProvider } from 'react-intl'
import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'
import { useRecoilValue } from 'recoil'

import { LanguageFilter } from '../../../../../atom'

type CancelModalProps = {
  isOpen: boolean
  onClose: () => void
  onYesClick: () => void
  onNoClick: () => void
}

export const CancelModal = ({
  isOpen,
  onClose,
  onYesClick,
  onNoClick,
}: CancelModalProps): JSX.Element => {
  const locale: any = useRecoilValue(LanguageFilter)
  return (
    <IntlProvider locale={locale}>
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalHeader>
            {locale === 'en'
              ? 'Confirm'
              : locale === 'si'
              ? 'තහවුරු කරන්න'
              : 'உறுதி'}
          </ModalHeader>
          <ModalBody whiteSpace="pre-line">
            {locale === 'en'
              ? 'Do you want to save as draft?'
              : locale === 'si'
              ? 'ඔබට කෙටුම්පතක් ලෙස සුරැකීමට අවශ්‍යද?'
              : 'வரைவாகச் சேமிக்க விரும்புகிறீர்களா?'}
          </ModalBody>
          <ModalFooter>
            <ButtonGroup>
              <Button onClick={onYesClick}>
                {locale === 'en' ? 'Yes' : locale === 'si' ? 'ඔව්' : 'ஆம்'}
              </Button>
              <Button onClick={onNoClick}>
                {locale === 'en' ? 'No' : locale === 'si' ? 'නැත' : 'இல்லை'}
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </IntlProvider>
  )
}
